import { withTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useState, useRef, useEffect } from "react";
import Page from "components/Page";
import Loader from "components/Loader";
import { useParams, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { decodeId } from "utils";
import { useCredentialLicenseById } from "repositories/user-repository";
import Text from "components/Text";
import {
  CredentialDataDescription,
  getCredentialExpiryDisplay,
} from "../Auth/components/Profile";
import moment from "moment";
import { getDocumentStatus } from "./CredentialTypeStatus";
import { CREDENTIAL_TYPE } from "features/credentials/credentialTypes";
import profileStyles from "../Auth/components/Profile/profile.module.scss";
import styles from "./CredentialsAndLicensingGlobalListing.module.scss";
import AddEditLincenseeModal from "../Auth/components/Profile/AddEditLincenseeModal";
import DeleteDocumentModal from "../Auth/components/Profile/DeleteDocumentModal";
import DeleteIcon from "assets/images/delete-red.svg";
import EditIcon from "assets/images/edit-icon.svg";
import toast from "react-hot-toast";
import constants from "../../constants";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";
import {
  getCredentialDisplayName,
  isOtherOwnerCredential,
} from "features/credentials/utils/normalizeCredentialMaster";
const CrdentialDetailPage = ({ t }) => {
  const history = useHistory();
  const location = useLocation();
  let { id } = useParams();
  id = id ? decodeId(id) : null;
  const {
    data: credentialDetail,
    refetch: refetchCredentialDetail,
    isLoading: credentialDetailLoading,
  } = useCredentialLicenseById(id);
  const [isModalOpen, setIsModalOpen] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const editDataRef = useRef(null);
const {getIdToCheckOwnerChange,selectedId}=useAccountOwnerCommon();
useEffect(() => {
  if(getIdToCheckOwnerChange()){
    history.push(constants.routes.credentialsAndLicensing.credentialsAndLicensingGlobal);
  }
}, [selectedId]);
  const isOtherOwner =
    isOtherOwnerCredential(credentialDetail) ||
    !!location.state?.isOtherOwner;
  const showManageActions = Boolean(credentialDetail) && !isOtherOwner;

  // Determine if it's an office credential (Type: 2) or staff credential (Type: 1)
  const isOfficeCredential = !!credentialDetail?.officeName;
  const modalHeading = isOfficeCredential
    ? t("accountOwner.editOfficeCredential")
    : t("accountOwner.editStaffCredential");
  const modalAddStaffOffice = isOfficeCredential
    ? "edit_office_credential"
    : "edit_staff_credential";

  const handleEditClick = () => {
    if (!showManageActions) return;

    // Map the credential detail data to match the modal's expected structure
    editDataRef.current = {
      ...credentialDetail, // Map credentialType to type for the modal
    };
    setIsModalOpen(modalAddStaffOffice);
  };

  const handleCloseModal = () => {
    setIsModalOpen(null);
    editDataRef.current = null;
  };

  const handleDeleteClick = () => {
    if (!showManageActions) return;
    setIsDeleteModalOpen(true);
  };

  const handleDownloadDocument = async (fileLink) => {
    if (!fileLink) return;
    try {
      toast.success(t("accountOwner.downloadingDocument"));
      const response = await fetch(fileLink);
      const blob = await response.blob();

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileLink.split("/").pop();

      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(link.href);
      toast.success(t("accountOwner.documentDownloadedSuccessfully"));
    } catch (error) {
      console.error("Error downloading file:", error);
      toast.error(t("accountOwner.errorDownloadingFile"));
    }
  };
  const goToPreviousScreen = () => {
    if (window.history.length > 1) {
      history.goBack();
    } else {
      history.push(
        constants.routes.credentialsAndLicensing.credentialsAndLicensingGlobal,
      );
    }
  };
  const documentStatus = getDocumentStatus(credentialDetail, t);
  return (
    <div className="staff-detail-block p-0">
      {credentialDetailLoading && <Loader />}
      <Page onBack={() => goToPreviousScreen()}>
        <div className="container-smd">
          <div className="row no-gutters align-items-center page_title_margin_top">
            <div className="col-md-7">
              <h2 className="page-title">
                {t("accountOwner.credentialsAndLicensingDetails")}
              </h2>
              <p className="sub-title">
                {credentialDetail?.userName ||
                  credentialDetail?.officeName ||
                  null}
              </p>
            </div>
          </div>
          <div className={"staff-detail-content " + styles.staffDetailContent}>
            <div className="row">
              <div className="col-12 d-flex justify-content-between align-items-center margin-bottom-40">
                <Text size="20px" weight="500" color="#111B45">
                  {getCredentialDisplayName(credentialDetail) || "-"}
                </Text>
                {showManageActions && (
                  <div className="d-flex gap-xs">
                    <button
                      className="reset-btn flex-shrink-null"
                      onClick={handleEditClick}
                    >
                      <img src={EditIcon} alt="edit" />
                    </button>
                    <button
                      className="reset-btn flex-shrink-null"
                      onClick={handleDeleteClick}
                    >
                      <img src={DeleteIcon} alt="DeleteIcon" />
                    </button>
                  </div>
                )}
              </div>
              <div className="col-12 d-flex justify-content-between">
                <CredentialDataDescription
                  heading={t("accountOwner.credentialName")}
                  description={getCredentialDisplayName(credentialDetail) || "-"}
                />
                {documentStatus.showHide && (
                  <span
                    className={
                      profileStyles["status"] +
                      " " +
                      profileStyles["status-" + documentStatus.customClass]
                    }
                  >
                    {documentStatus.status}
                  </span>
                )}
              </div>
              <div className="col-lg-5">
                <CredentialDataDescription
                  heading={t("accountOwner.credentialType")}
                  description={
                    credentialDetail?.credentialType
                      ? CREDENTIAL_TYPE.find(
                          (item) =>
                            item.id === +credentialDetail?.credentialType,
                        )?.name
                      : "-"
                  }
                />
                <CredentialDataDescription
                  heading={t("accountOwner.issuingAuthority")}
                  description={credentialDetail?.issuingAuthority || "-"}
                />
                <CredentialDataDescription
                  heading={t("accountOwner.credentialId")}
                  description={credentialDetail?.credentialId || "-"}
                />
                <div className="d-flex justify-content-between">
                  <CredentialDataDescription
                    heading={t("accountOwner.issueDate")}
                    description={
                      credentialDetail?.issueDate
                        ? moment(credentialDetail?.issueDate).format(
                            "MMM DD, YYYY",
                          )
                        : "-"
                    }
                  />
                  <CredentialDataDescription
                    heading={t("accountOwner.expiryDate")}
                    description={getCredentialExpiryDisplay(
                      credentialDetail,
                      t,
                      {
                        withExpiresPrefix: false,
                        dateFormat: "MMM DD, YYYY",
                      },
                    )}
                  />
                </div>
                {credentialDetail?.proofDocumentPath && (
                  <div className={profileStyles["credential-card__row"]}>
                    <dt className={profileStyles["credential-card__label"]}>
                      {t("accountOwner.proofDocument")}
                    </dt>
                    <dd
                      className={
                        profileStyles["credential-card__value"] +
                        " d-flex justify-content-between align-items-center"
                      }
                    >
                      <span>
                        {credentialDetail?.proofDocumentPath
                          ?.split("/")
                          ?.pop() || "-"}
                      </span>
                      <button
                        className={styles["downloading-btn"]}
                        id={"download-document"}
                        onClick={() =>
                          handleDownloadDocument(
                            credentialDetail?.proofDocumentPath,
                          )
                        }
                      >
                        {t("accountOwner.download")}
                      </button>
                    </dd>
                  </div>
                )}
                <div className={profileStyles["credential-card__row"]}>
                  <dl>
                    <dt className={profileStyles["credential-card__label"]}>
                      {t("accountOwner.additionalDocuments")}
                    </dt>
                    {credentialDetail?.additionalDocuments?.length > 0
                      ? credentialDetail.additionalDocuments.map(
                          (document, i) => (
                            <dd
                              key={document?.id}
                              className={
                                profileStyles["credential-card__value"] +
                                " d-flex justify-content-between align-items-center" +
                                profileStyles["credential-list"]
                              }
                            >
                              <span>
                                {document?.documentPath?.split("/")?.pop() ||
                                  "-"}
                              </span>
                              {document?.documentPath && (
                                <button
                                  className={styles["downloading-btn"]}
                                  id={"download-document" + i}
                                  onClick={() =>
                                    handleDownloadDocument(
                                      document.documentPath,
                                    )
                                  }
                                >
                                  {t("accountOwner.download")}
                                </button>
                              )}
                            </dd>
                          ),
                        )
                      : "--"}
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Page>
      {isModalOpen && showManageActions && (
        <AddEditLincenseeModal
          isModalOpen={isModalOpen !== null}
          closeModal={handleCloseModal}
          heading={modalHeading}
          addStaffOffice={modalAddStaffOffice}
          editData={editDataRef.current}
          refetchData={refetchCredentialDetail}
        />
      )}
      {isDeleteModalOpen && showManageActions && (
        <DeleteDocumentModal
          credentialId={credentialDetail?.id}
          onClose={() => {
            setIsDeleteModalOpen(false);
          }}
          refetchData={() => {
            // Redirect to back page after successful deletion
            // The modal calls refetchData only after successful deletion
            setTimeout(() => {
              history.goBack();
            }, 100);
          }}
        />
      )}
    </div>
  );
};

export default withTranslation()(CrdentialDetailPage);
